"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAvailableDisplayFormRefs = void 0;
function loadAvailableDisplayFormRefs(ctx, displayForms) {
    var backend = ctx.backend, workspace = ctx.workspace;
    return backend
        .workspace(workspace)
        .attributes()
        .getAttributeDisplayForms(displayForms)
        .then(function (references) { return references.map(function (df) { return df.ref; }); });
}
exports.loadAvailableDisplayFormRefs = loadAvailableDisplayFormRefs;
//# sourceMappingURL=loadAvailableDisplayFormRefs.js.map